import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import type { PrehledReport } from '@/modules/leasing/api';
import { Route as RootRoute } from './__root';

const LeasingPrehledTisk = lazy(() =>
  import('@/modules/leasing/LeasingPrehledTisk').then((m) => ({
    default: m.LeasingPrehledTisk,
  })),
);

interface PrehledTiskSearch {
  report?: PrehledReport;
  mesic?: string;
}

const REPORT_VALUES = ['splatky', 'smlouvy-ukonceni', 'uvery', 'uvery-ukonceni'] as const;
const MESIC_RX = /^\d{4}-\d{2}$/;

function parsePrehledTiskSearch(input: Record<string, unknown>): PrehledTiskSearch {
  const out: PrehledTiskSearch = {};
  const r = input.report;
  if (typeof r === 'string' && (REPORT_VALUES as readonly string[]).includes(r)) {
    out.report = r as PrehledReport;
  }
  const m = input.mesic;
  if (typeof m === 'string' && MESIC_RX.test(m)) out.mesic = m;
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/prehledy/tisk',
  component: () => (
    <Suspense fallback={null}>
      <LeasingPrehledTisk />
    </Suspense>
  ),
  validateSearch: parsePrehledTiskSearch,
});
